import { render, staticRenderFns } from "./ArmariosToolbar.vue?vue&type=template&id=4708ec50&scoped=true"
import script from "./ArmariosToolbar.vue?vue&type=script&lang=js"
export * from "./ArmariosToolbar.vue?vue&type=script&lang=js"
import style0 from "./ArmariosToolbar.vue?vue&type=style&index=0&id=4708ec50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708ec50",
  null
  
)

export default component.exports